// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function Light_click() {
	$w('#slideshow1').changeSlide(0);
}

export function ClimaComfort_click() {
	$w('#slideshow1').changeSlide(1);
}

export function Stealth_click() {
	$w('#slideshow1').changeSlide(2); 
}

export function Night_click() {
	$w('#slideshow1').changeSlide(3); 
}

export function LightBL_click(event) {
	$w('#slideshow1').changeSlide(4); 
}

export function Optimum_click() {
	$w('#slideshow1').changeSlide(5); 
}

export function Xair80_click() {
	$w('#slideshow1').changeSlide(6); 
}

export function Light_mouseIn() {
	$w('#slideshow1').changeSlide(0);
}

export function ClimaComfort_mouseIn() {
	$w('#slideshow1').changeSlide(1);
}

export function Stealth_mouseIn() {
	$w('#slideshow1').changeSlide(2);
}

export function Night_mouseIn() {
	$w('#slideshow1').changeSlide(3);
}

export function LightBL_mouseIn() {
	$w('#slideshow1').changeSlide(4);
}

export function Optimum_mouseIn() {
	$w('#slideshow1').changeSlide(5);
}

export function Xair80_mouseIn() {
	$w('#slideshow1').changeSlide(6);
}